import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpointOidcProviderQueryKeys, EndpointOIDCProviders, googleIdPQueryKeys } from '#api';

export function useDeleteEndpointIdentityProviderMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (endpointOIDCID: string) => EndpointOIDCProviders.deleteEndpointOIDCProvider(endpointOIDCID),
    onSuccess: (data, endpointOIDCID) => {
      queryClient.removeQueries({ queryKey: endpointOidcProviderQueryKeys.detail(endpointOIDCID), exact: true });
      void queryClient.invalidateQueries({ queryKey: endpointOidcProviderQueryKeys.lists() });
      // Which providers are Google, and whether the directory connection is paused, follow the providers.
      void queryClient.invalidateQueries({ queryKey: googleIdPQueryKeys.all() });
    },
  });
}
